import { render } from "./SettingTemplateDrawer.vue?vue&type=template&id=1aa8b3b6"
import script from "./js/settingTemplateDrawer.js?vue&type=script&lang=js&external"
export * from "./js/settingTemplateDrawer.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__